'use strict';

const $ = jQuery.noConflict();
$(function() {

	const loadMore = {

		currentPage: 1,
		$domLoadMoreBtnWrapper: $('.post-listing .js-load-more'),
		$domLoadMoreBtn: $('.post-listing .js-load-more .btn'),
		$domItemsContainer: $('.post-listing .js-load-more-container'),

		// initialize
		init: function() {
			this.$domLoadMoreBtn.on('click', this.onLoadMoreClick);
		},

		// handle click on "load more" button
		// eslint-disable-next-line no-unused-vars
		onLoadMoreClick(event) {
			loadMore.showSpinner(true);
			const data = {
				action: 'fws-post-listing-load-more',
				page: loadMore.currentPage + 1,
			};
			$.ajax({
				method: 'POST',
				url: window.fwsLocalized.ajaxUrl,
				data: data,
				success: loadMore.onSuccess,
				error: loadMore.onError,
				complete: loadMore.onComplete,
			});
		},

		// handle "success" response
		onSuccess: function(response) {
			console.log('resp', response);
			if (!response.data || response.data.status) {
				return;
			}
			// add content to DOM
			if (response.data.html) {
				loadMore.$domItemsContainer.append(response.data.html);
				loadMore.currentPage = response.data.page;
			}
			// hide button when no more posts
			if (!response.data.hasMore) {
				loadMore.$domLoadMoreBtn.hide();
			}
		},

		// handle "error" response
		onError: function(jqXHR, textStatus, errorThrown) {
			console.error('AJAX error: ' + textStatus + ' - ' + errorThrown);
		},

		// handle "complete" response
		onComplete: function() {
			loadMore.showSpinner(false);
		},

		// toggle spinner
		showSpinner: function(state) {
			// toggle
			this.$domLoadMoreBtnWrapper.toggleClass('show-spinner', state);
		},

		// push page to url
		//changeUrl: function(page) {
		//	const url = document.location.origin + document.location.pathname + 'page/' + page + '/';
		//	window.history.pushState('', '', url);
		//},
	};

	loadMore.init();
});

